import { anyReallyAny } from "@cervval.js/common/tools";

/** Accept only enum with enum key fully upper case and value NOT fully upper case */
export function getEnumValues<T>(e: anyReallyAny): T[] {
    return Object.keys(e)
        .filter(key => key.match(/^[A-Z]*$/) != null || isNaN(parseInt(key, 10))) // Keep only number and KEY (all upper case)
        .map(key => e[key]);
}